<template>
  <!-- 简历组件 - 个人信息 -->
  <!-- 最外部div  Editor等于1时 是未点击编辑按钮 正常显示个人基本信息  等于2时是点击了编辑展示编辑个人信息栏 -->
  <div :class="Editor == 1 ? 'user' : 'user-editor'">
    <!-- 正常显示 个人信息 -->
    <div class="User-box" v-if="Editor == '1'">
      <!-- 正常展示 头像区 -->
      <div class="avatar">
        <!-- 放头像的div -->
        <div class="avatar-box">
          <!-- 头像图片 -->
          <img :src="data.userImg" alt="" />
          <!-- 头像右上的vip -->
          <!-- <img
            class="img-vip"
            src="../../../../../../assets/imgs/VIP@3x.svg"
            alt=""
          /> -->
        </div>
        <div class="avatar-id">
          <!-- id -->
          <p :title="data.code">ID:{{ data.code }}</p>
          <!-- 个人二维码 -->
          <!-- <div class="code firm-clickable" @click="dialogVisibleCode = true">
            <img
              src="../../../../../../assets/imgs/img/geren-SVG/erweima@3x.svg"
              alt=""
            />
          </div> -->
        </div>
      </div>
      <!-- 分割线 -->
      <div class="placeholder"></div>
      <!-- 正常展示 信息区 -->
      <div class="Message">
        <!-- 右上角编辑 icon -->
        <img
          @click="handelClick"
          class="EDITOR firm-clickable"
          src="../../../../../../assets/imgs/bianji@3x.svg"
          alt=""
        />
        <!-- 个人基本信息 -->
        <div class="Message-box">
          <p class="Message-name">{{ data.username }}</p>
          <p class="Message-top-p">
            {{ data.sex == "0" ? "女" : data.sex == "1" ? "男" : "" }}
            <i v-if="data.sex == 1" class="el-icon-male"></i>
            <i v-if="data.sex == 0" class="el-icon-female"></i>
          </p>
          <p class="Message-top-p">{{ childYears + "岁" }}</p>

          <p class="Message-top-p">
            {{
              data.xl == "0"
                ? "初中"
                : data.xl == "1"
                ? "中专/中技"
                : data.xl == "2"
                ? "高中"
                : data.xl == "3"
                ? "大专"
                : data.xl == "4"
                ? "本科"
                : data.xl == "5"
                ? "硕士"
                : data.xl == "6"
                ? "博士"
                : ""
            }}
          </p>
        </div>
        <!-- 定位电话邮箱等 -->
        <div class="Message-box">
          <div class="Message-icon">
            <img src="../../../../../../assets/imgs/dingwei@3x.svg" alt="" />
          </div>
          <p class="Message-btm-p">{{ data.address }}</p>
          <div class="Message-icon">
            <img src="../../../../../../assets/imgs/shenfen@3x.svg" alt="" />
          </div>
          <p class="Message-btm-p">
            {{ data.work == "0" ? "职场精英" : "学生" }}
          </p>
          <div class="Message-icon">
            <img src="../../../../../../assets/imgs/dianhua-weijiaohuan@3x.svg" alt="" />
          </div>
          <p class="Message-btm-p">{{ data.phone }}</p>
          <div class="Message-icon">
            <img src="../../../../../../assets/imgs/youxiang@3x.svg" alt="" />
          </div>
          <p class="Message-btm-p">{{ data.mail }}</p>
        </div>
      </div>
    </div>
    <!-- 显示编辑个人信息栏 -->
    <div class="User-box-EDITOR" v-else>
      <div class="EDITOR-top">
        <div class="EDITOR-top-title">
          <p v-for="(item, index) in userArr" :key="index">
            <span v-if="item.required == '1'" style="color: red">*</span
            >{{ item.name }}：
          </p>
        </div>
        <div class="EDITOR-top-ipt">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- 姓名框 -->
            <div class="input-place">
              <el-form-item prop="username">
                <el-input
                  v-model="ruleForm.username"
                  placeholder="请输入姓名"
                  :disabled="
                    this.AuditInfoObj.status == 1 ||
                    this.AuditInfoObj.status == 3
                      ? true
                      : false
                  "
                ></el-input>
              </el-form-item>
            </div>

            <!-- 性别选择 -->
            <div class="input-place">
              <p
                v-for="(item, index) in sexSelectArr"
                :key="index"
                :class="ruleForm.sex == item.id ? 'Select-p' : ''"
                @click="handelSexSelect(item)"
              >
                {{ item.Options }}
              </p>
            </div>
            <!-- 身份选择 -->
            <div class="input-place">
              <p
                v-for="(item, index) in standingArr"
                :key="index"
                :class="ruleForm.work == item.id ? 'Select-p' : ''"
                @click="handelStanDing(item)"
              >
                {{ item.Options }}
              </p>
            </div>
            <!-- 出生年月日 -->
            <div class="input-place">
              <el-form-item prop="birthday">
                <el-date-picker
                  class="timeSelect"
                  :clearable="false"
                  v-model="ruleForm.birthday"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="timestamp"
                  @change="handelChange(1)"
                >
                </el-date-picker>
              </el-form-item>
              <div class="ageEcho" v-if="years != ''">{{ years + "岁" }}</div>
            </div>
            <!-- 首次参加工作时间 -->
            <div class="input-place">
              <el-form-item>
                <el-date-picker
                  class="timeSelect"
                  :clearable="false"
                  v-model="ruleForm.firstWorkTime"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="timestamp"
                  @change="handelChange(2)"
                >
                </el-date-picker>
              </el-form-item>
              <div class="ageEcho" v-if="yearsAge != ''">
                {{ yearsAge + "年" }}
              </div>
            </div>
            <!-- 地址框 -->
            <div class="input-place" @click="handelSelectAddress()">
              <el-form-item prop="address">
                <el-input
                  v-model="ruleForm.address"
                  placeholder="请选择地址"
                  readonly
                ></el-input>
              </el-form-item>
            </div>

            <!-- 联系方式 -->
            <div class="input-place">
              <p class="connection">{{ this.$store.getters.getUser.phone }}</p>
              <p class="connection firm-clickable" style="color: #409eff " @click="handelEdit">
                修改
              </p>
            </div>
            <!-- 电子邮箱 -->
            <div class="input-place">
              <p class="connection">{{ this.$store.getters.getUser.mail }}</p>
              <p class="connection firm-clickable" style="color: #409eff " @click="handelEdit">
                修改
              </p>
            </div>
          </el-form>
        </div>

        <!-- 编辑头像 -->
        <div class="Edit-Avatar">
          <div class="Edit-Avatar-box">
            <div class="img-logo" v-loading="loading">
              <div class="firm-clickable" @click="clickFile(1)"></div>
              <img
                :src="ruleForm.userImg"
                alt=""
                v-if="ruleForm.userImg != ''"
              />
              <input
                type="file"
                ref="clearFile"
                @change="onFileChange"
                id="file"
              />
              <input type="button" class="btn firm-clickable" @click="clickFile(1)" />
            </div>
            <div class="LookOut">
              只支持JPG、PNG格式,大小不要超过10M 建议使用一寸证件照100*100像素
            </div>
          </div>
        </div>
      </div>
      <!-- 完成编辑 / 取消编辑 -->
      <div class="EDITOR-btm">
        <p class="Cancel" @click="handelCancel">取消</p>
        <p class="verify" @click="handelSubmit('ruleForm')">确认</p>
      </div>
    </div>
    <!-- :distinguish='0'区分是那部分使用的地址选择，最后返回的值不同 -->
    <Address
      :dialogAddress="dialogAddress"
      :distinguish="0"
      :addressCode="ruleForm.addressCode"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Address>
    <!-- 放大二维码 -->
    <dialogModel
      :visible.sync="dialogVisibleCode"
      :footer="false"
      @handleClose="handleCloseCode"
    >
      <div class="img-box">
        <!-- QR code image removed - unused file deleted -->
      </div>
    </dialogModel>
    <!-- 已实名认证后修改基本信息中的姓名 弹窗提示二次确认 -->
    <dialogModel
      title="提示"
      :visible.sync="dialogVisibleInRealName"
      @handleClose="handleCloseInRealName"
      @handleOk="handleInRealName"
    >
      <p>你已经实名认证，若修改姓名则需重新进行实名认证，是否继续?</p>
    </dialogModel>
  </div>
</template>

<script>
// 引入接口
import {
  updateUserResumes, // 修改简历
} from "../../../../../../assets/api/CenterJane";
import {
  postGetIdentityAuditInfo, // 个人中心-身份验证-身份认证/支付密码信息页面查询
} from "../../../../../../assets/api/index";
// 个人信息
import Address from "./addres.vue";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
import { mapActions } from "vuex";
export default {
  props: {
    data: {},
    childYears: {},
  },
  data() {
    return {
      dialogVisibleCode: false, //放大二维码
      dialogAddress: false, // 切换地址
      dialogVisibleInRealName: false, //已实名认证的情况下修改用户姓名，打开弹窗提示二次确认
      imgSrc: require("../../../../../../assets/imgs/tx1@3x.svg"), // 预览头像路径
      TXurl: "", // 头像上传到腾讯云仓库的地址
      Editor: "1", //1正常展示个人信息  2编辑个人信息
      userArr: [
        { name: "姓名", required: "1" },
        { name: "性别", required: "1" },
        { name: "身份", required: "1" },
        { name: "出生年月", required: "1" },
        { name: "首次参加工作时间" },
        { name: "地址", required: "1" },
        { name: "联系方式" },
        { name: "电子邮箱" },
      ], // ipt名 用于循环生成input框前的标题
      input: "", // input框
      sexSelectArr: [
        { Options: "女", id: "0" },
        { Options: "男", id: "1" },
      ], // 性别选择

      standingArr: [
        { Options: "职场精英", id: "0" },
        { Options: "学生", id: "1" },
      ], // 身份选择

      years: "", // 年龄
      yearsAge: "", // 工作年
      ruleForm: {
        userId: "",
        username: "", // 姓名
        sex: "0", // 选中的性别
        work: "0", // 身份选择选中
        birthday: "", // 出生年月日
        firstWorkTime: "", // 首次参加工作时间
        address: "", // 地址
        addressCode: "", //地址编码
        userImg: "", // 头像地址
      }, // v-mode
      rules: {
        username: vxRule(true, "UserName", "blur", "请输入姓名"),
        address: vxRule(true, "", "blur", "请选择地址"),
        birthday: vxRule(true, "", "blur", "请选择出生年月日"),
      }, // 表单验证
      userYears: "", //年龄，初始化展示时使用
      AuditInfoObj: {}, //个人中心-身份验证-身份认证/支付密码信息页面查询
      loading: false,
    };
  },
  watch: {
    Editor: {
      handler(newSs, old) {
        if (newSs == "2") {
          this.ruleForm.userImg = this.data.userImg;
        } else {
          this.ruleForm.userImg = "";
        }
      },
    },
    // 监听 年龄是否满16

    years: {
      handler(newSs, old) {
        if (newSs < 16 && newSs != "-") {
          this.$tool.PromptBox(
            "error",
            "未满16周岁，不可进行修改，请重新选择出生年月"
          );
          this.years = "-";
          this.ruleForm.birthday = "";
        }
      },
    },
    // 监听 工作年限判断是不是16岁以后工作的
    yearsAge: {
      handler(newSs, old) {
        // 选择首次参加工作年时先确保已经正确选择出生年月日
        if (this.years == "" || this.years == null || this.years == "-") {
          if (this.yearsAge != "-") {
            this.$tool.PromptBox("error", "请先选择出生年月日");
            this.yearsAge = "-";
            this.ruleForm.firstWorkTime = "";
          }
        } else {
          var i = this.years - newSs;
          if (i < 16) {
            this.$tool.PromptBox("error", "请选择正确的参加工作日期");
            this.yearsAge = "-";
            this.ruleForm.firstWorkTime = "";
          }
        }
      },
    },
  },
  created() {
    // 年龄
    this.userYears = localStorage.getItem("years");
    // 个人中心-身份验证-身份认证/支付密码信息页面查询
    this.postGetIdentityAuditInfo();
  },
  components: { Address },

  methods: {
    ...mapActions(["SET_USERINFO_UserImg"]),
    // 个人中心-身份验证-身份认证/支付密码信息页面查询
    postGetIdentityAuditInfo() {
      var data = { data: {} };
      postGetIdentityAuditInfo(data).then((res) => {
        this.AuditInfoObj = res.data;
      });
    },
    // 点击上传
    clickFile(num) {
      const input = document.querySelector("#file");
      input.click();
    },
    async onFileChange(event, opt, callback) {
      this.loading = true;
      var file = event.target.files[0] || event.dataTransfer.files[0];
      var fileSuffix1 = file.name;
      var fileArr = fileSuffix1.split(".");
      var fileSuffix = fileArr[fileArr.length - 1]; // 获取上传文件的后缀确认是否符合要求
      if (
        fileSuffix == "jpg" ||
        fileSuffix == "JPG" ||
        fileSuffix == "png" ||
        fileSuffix == "PNG"
      ) {
        let URL = window.URL || window.webkitURL; // 当前地址

        var arr = await this.$tool.onFileChangeNew(event, opt, callback);
        console.log(arr, "arr");
        if (arr.code == 0) {
          this.loading = false;
          this.TXurl = arr.TXurl;
          this.ruleForm.userImg = arr.TXurl; // 转成 blob地址 //用于回显选择的头像
        } else {
          this.loading = false;
        }
        this.$refs.clearFile.value = ""; // 清空file文件
      } else {
        // 上传文件不符合要求
        this.loading = false;
        this.$tool.PromptBox("error", "请上传jpg/png文件");
      }
    },
    // 点x重新上传头像
    handelSwitch() {
      this.ruleForm.userImg = "";
    },
    // 放大二维码弹窗
    handleCloseCode() {
      this.dialogVisibleCode = false;
    },
    // 切换地址关闭弹窗
    handleClose() {
      this.dialogAddress = !this.dialogAddress;
    },
    // 切换地址弹窗确定
    handleUnderstand(val, code) {
      this.ruleForm.address = val;
      this.ruleForm.addressCode = code;
      this.dialogAddress = !this.dialogAddress;
    },

    // 点击地址框打开地址选择弹窗
    handelSelectAddress() {
      console.log("48548");
      this.dialogAddress = true;
    },
    // 点击修改联系方式/邮箱
    handelEdit() {
      this.$router.push("/Centre/cenAccount");
    },

    // 取消编辑
    handelCancel() {
      this.Editor = "1";
    },
    // 编辑提交
    handelSubmit(formName) {
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.ruleForm.username != this.AuditInfoObj.username) {
          //   this.dialogVisibleInRealName = true;
          // } else {
          this.handleInRealName();
          // }
        } else {
          return false;
        }
      });
    },
    //已实名认证修改姓名二次确认 取消
    handleCloseInRealName() {
      this.dialogVisibleInRealName = false;
    },
    // 已实名认证修改姓名二次确认  确定
    handleInRealName() {
      var data = {};
      this.ruleForm.userId = this.$store.getters.getUser.id;

      // this.ruleForm.userImg = this.TXurl;
      data.data = this.ruleForm;
      // 删除address字段，接口不需要
      delete data.data.address;

      // 调用接口修改简历个人信息
      updateUserResumes(data).then((res) => {
        if (res.code == 0) {
          this.$emit("handelSubmit");
          // 成功
          this.$store.commit("SET_USERINFO_UserImg", this.ruleForm.userImg);
          this.$tool.PromptBox("success", "修改成功");
          // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
          this.Editor = "1";
        } else {
          // 失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
      this.dialogVisibleInRealName = false;
    },
    // 编辑
    handelClick() {
      this.Editor = "2";
      // 编辑框的数据回显
      this.ruleForm.username = this.data.username;
      this.ruleForm.sex = this.data.sex;
      this.ruleForm.work = this.data.work;
      if (this.data.birthday) {
        this.ruleForm.birthday = Date.parse(new Date(this.data.birthday));
        this.handelChange(1);
      } else {
        this.ruleForm.birthday = "";
        this.years = "";
      }
      if (this.data.firstWorkTime) {
        this.ruleForm.firstWorkTime = Date.parse(
          new Date(this.data.firstWorkTime)
        );
        this.handelChange(2);
      } else {
        this.ruleForm.firstWorkTime = "";
        this.yearsAge = "";
      }
      this.ruleForm.address = this.data.address;
      this.ruleForm.addressCode = this.data.addressCode;
    },
    // 日期选择后触发
    handelChange(num) {
      // 1是出生年月日计算  2是工作年数计算
      if (num == 1) {
        //时间戳转年月日函数，用于传参
        console.log(this.$tool.turnTime(this.ruleForm.birthday));
        // 当前时间戳减去选择日期的时间戳计算后获取年龄
        this.years = this.$tool.compute(this.ruleForm.birthday);
      } else {
        //时间戳转年月日函数，用于传参
        console.log(this.$tool.turnTime(this.ruleForm.firstWorkTime));
        // 当前时间戳减去选择日期的时间戳计算后获取工作年限
        // this.$tool.compute调用封装好的函数，(this.ruleForm.firstWorkTime)传递的参数
        this.yearsAge = this.$tool.compute(this.ruleForm.firstWorkTime);
      }
    },
    // 性别选择
    handelSexSelect(item) {
      this.ruleForm.sex = item.id;
    },
    // 身份选择
    handelStanDing(item) {
      this.ruleForm.work = item.id;
    },
  },
};
</script>

<style scoped lang="less">
// 编辑修改 姓名 二次确认弹窗
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
      margin-right: 20px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.img-box {
  width: 100%;
  height: 150px;
  display: flex;
  img {
    width: 130px;
    height: 130px;
    margin: auto;
  }
}

/deep/.el-form-item {
  width: 100%;
  margin-bottom: 0px;
  height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}

// 头像编辑 下方的文字style
.LookOut {
  width: 100%;
  height: 30px;
  font-size: 10px;
  color: #999999;
  text-align: center;
  line-height: 15px;
  font-weight: 400;
  text-align: center;
  margin-top: 10px;
}
.img-logo {
  width: 70px;
  height: 70px;
  position: relative;
  margin: auto;
  img {
    width: 100%;
    height: 100%;
  }
  #file {
    display: none;
  }
  #file1 {
    display: none;
  }
  input {
    border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    width: 100%;
    height: 60px;
    text-align: center;
    color: #409eff ;
    position: absolute;
    left: 0px;
  }
  div {
    width: 18px;
    height: 18px;
    background-image: url("../../../../../../assets/imgs/guanbi@3x.svg");
    background-repeat: no-repeat;
    position: absolute;
    right: 5px;
    top: -8px;
  }
}
// 修改组件库 input 的css样式
/deep/.el-input__inner {
  width: 360px;
  width: 100% !important;
  height: 35px;
  border: 1px solid #409eff ;
  border-radius: 5px;
  //   border-right: none;
}
/deep/ .el-date-editor--date {
  width: 350px !important;
}
// 修改组件库 时间选择框中自带的icon图标样式
/deep/.el-input__icon {
  // font-size: 20px !important;
  margin-top: -3px;
}
// 年龄回显
.ageEcho {
  width: 90px;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
  background: rgba(97, 144, 232, 0.27);
  border-left: 0.5px solid #409eff ;
  border-radius: 0px 5px 5px 0px;
  position: absolute;
  right: 0;
  top: 4px;
  font-size: 12px;
  color: #409eff ;
  text-align: center;
  font-weight: 400;
}
// 正常展示
.user {
  width: 100%;
  min-height: 100px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
}
// 编辑
.user-editor {
  width: 100%;
  min-height: 100px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
}
// 正常展示个人信息
.User-box {
  flex: 1;
  min-height: 80px;
  margin: 10px 20px 10px 20px;
  display: flex;
  //   头像
  .avatar {
    min-width: 110px;
    min-height: 80px;
    // 放头像的div
    .avatar-box {
      width: 60px;
      height: 60px;
      margin: 0 auto;
      position: relative;
      // 头像图片的大小
      img {
        width: 100%;
        height: 100%;
      }
      // 邮箱右上角vip
      .img-vip {
        width: 33px;
        height: 12px;
        position: absolute;
        right: -10px;
      }
    }
    // 头像下方的id
    .avatar-id {
      width: 100%;
      height: 16px;
      margin-top: 4px;
      display: flex;
      p {
        flex: 1;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      // 个人二维码样式
      .code {
        width: 16px;
        height: 16px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
        }
      }
    }
  }
  // 分割线样式
  .placeholder {
    min-height: 80px;
    border-left: 1px solid #eeeeee;
    margin-left: 20px;
    margin-right: 20px;
  }
  // 个人基本信息div
  .Message {
    flex: 1;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    position: relative;
    // 编辑icon 的样式
    .EDITOR {
      width: 20px;
      height: 20px;
      position: absolute;
      right: -10px;
      cursor: pointer;
    }
    // 个人基本信息的div
    .Message-box {
      width: 100%;
      height: 25px;
      line-height: 25px;
      margin: auto;
      display: flex;
      // 定位 电话 邮箱 等icon图标大小 位置
      .Message-icon {
        width: 20px;
        height: 18px;
        margin-right: 5px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .Message-icon:nth-child(1) {
        height: 22px;
      }
      // 个人基本信息 文字的样式
      p {
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      }
      .Message-top-p {
        margin-right: 20px;
        i {
          font-size: 16px;
        }
      }
      .Message-btm-p {
        min-width: 50px;
        max-width: 180px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 40px;
      }
      .Message-name {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #333333;
        font-weight: 400;
        margin-right: 20px;
      }
    }
  }
}
// 编辑栏的大div
.User-box-EDITOR {
  flex: 1;
  margin: 30px 20px 20px 30px;
  display: flex;
  flex-direction: column;

  //编辑框 编辑内容的大div
  .EDITOR-top {
    width: 100%;
    display: flex;
    // 每条input框前方的 标题
    .EDITOR-top-title {
      min-width: 100px;
      height: 100%;
      p {
        height: 35px;
        text-align: right;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333333;
        text-align: right;
        line-height: 35px;
        font-weight: 400;
        margin-bottom: 25px;
      }
    }
    // 放input的大div
    .EDITOR-top-ipt {
      width: 350px;
      height: 100%;
      // 放input的div 用于限制调整input的大小
      .input-place {
        width: 100%;
        height: 35px;
        margin-top: 25px;
        display: flex;
        position: relative;
        // 联系方式
        .connection {
          border: none;
          line-height: 37px;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }
        .Select-p {
          background: rgba(97, 144, 232, 0.27);
        }
        p {
          margin-left: 15px;
          min-width: 90px;
          height: 35px;
          line-height: 35px;
          background: #ffffff;
          border: 1px solid #409eff ;
          border-radius: 5px;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #409eff ;
          text-align: center;
          font-weight: 400;
        }
        p:nth-child(1) {
          margin-left: 0;
        }
      }
      .input-place:nth-child(1) {
        margin-top: 0;
      }
    }
    .Edit-Avatar {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      .Edit-Avatar-box {
        width: 170px;
        height: 120px;
      }
    }
  }
  // 编辑栏下方的 取消 确认 按钮样式
  .EDITOR-btm {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: flex-end;
    .Cancel {
      box-sizing: border-box;
      border: 1px solid #999999;
      color: #333333;
      margin-right: 20px;
      cursor: pointer;
    }
    .verify {
      background: #409eff ;
      color: #ffffff;
      cursor: pointer;
    }
    p {
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
